import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { RiLock2Line, RiShieldCheckLine } from "react-icons/ri";
import mada from "../../styles/images/mada.svg";
import mc from "../../styles/images/mc.svg";
import visa from "../../styles/images/visa.svg";

export type HyperPayShellVariant = "visa-master" | "mada";

interface HyperPayModalShellProps {
  titleId?: string;
  title: string;
  trustLine: string;
  variant: HyperPayShellVariant;
  children: ReactNode;
}

const HyperPayModalShell = ({
  titleId = "ac-hyperpay-modal-title",
  title,
  trustLine,
  variant,
  children,
}: HyperPayModalShellProps) => {
  const { t } = useTranslation();

  return (
    <div className="ac-hyperpay-shell ac-hyperpay-shell--light ac--font-expo">
      <aside className="ac-hyperpay-shell__aside">
        <span className="ac-hyperpay-shell__eyebrow">
          <RiLock2Line aria-hidden /> {t("payment.checkoutLabel")}
        </span>
        <div className="ac-hyperpay-shell__card-art" aria-hidden>
          <span className="ac-hyperpay-shell__card-chip" />
          <span className="ac-hyperpay-shell__card-wave" />
          <span className="ac-hyperpay-shell__card-mark">AC</span>
        </div>
        <div className="ac-hyperpay-shell__aside-copy">
          <RiShieldCheckLine aria-hidden />
          <span>{trustLine}</span>
        </div>
      </aside>

      <div className="ac-hyperpay-shell__main">
        <header className="ac-hyperpay-shell__header">
          <span className="ac-hyperpay-shell__step">{t("payment.cardStep")}</span>
          <h2 className="ac-hyperpay-shell__title" id={titleId}>{title}</h2>
          <p className="ac-hyperpay-shell__intro">{t("payment.cardIntro")}</p>
          <div className="ac-hyperpay-shell__brands" aria-label={t("payment.acceptedCards")}>
            {variant === "mada" ? (
              <img src={mada} alt={t("payment.mada")} />
            ) : (
              <>
                <img src={mada} alt={t("payment.mada")} />
                <img src={visa} alt={t("payment.visa")} />
                <img src={mc} alt={t("payment.master")} />
              </>
            )}
          </div>
        </header>
        <div className="ac-hyperpay-shell__body">{children}</div>
      </div>
    </div>
  );
};

export default HyperPayModalShell;
